const ImplementFeatures =  ()=>{
    return (
        <>
        <section className=" flex flex-col gap-4">
            <h1 className='uppercase font-medium w-full
                        xl:text-4xl xl:pb-12
                        lg:text-4xl lg:pb-12
                        md:text-3xl md:pb-10
                        sm:text-[28px] sm:pb-4'>Навигационная система</h1>
                <div>
                    <h2 className="font-bold text-3xl sm:text-xl
                                    xl:pb-6
                                    lg:pb-6  
                                    md:pb-4 
                                    sm:pb-2">Резервирование и комплексирование</h2>
                    <p> 
                        IMU: BMI055+BMI270+QMI8658 <br/>
                        Compass QMC5583+BMM150<br/>
                        Barometr:BMP388<br/>
                        Такой набор датчиков обеспечивает точность, быстроту сбора данных, а также отказоустойчивость системы навигаиции и ориентации ЛА.
                    </p>
                </div>

                <div>
                    <h2 className="font-bold text-3xl sm:text-xl
                                    xl:pb-6
                                    lg:pb-6  
                                    md:pb-4 
                                    sm:pb-2">Термостатирование</h2>
                    <p>
                    Все датчики находятся внутри теплоизолированного контура, который обеспечивает стабильность данных мемс-датчиков, и возможность рабты при низких температурах.
                    4 нагревателя и 4 термометра обеспечивают равномерный нагрев датчиков со всех сторон.
                </p>
                </div>
                
                <div>
                    <h2 className="font-bold text-3xl sm:text-xl
                                    xl:pb-6
                                    lg:pb-6  
                                    md:pb-4 
                                    sm:pb-2">Виброразвязка</h2>
                    <p>8 виброизоляторов из термопластичного полиуретана для всего полетного контроллера, и 2 виброизолятора из вспененного полиуретана, демпфируют все вибрации связанные с движением ЛА, обеспечивая точность системы ориентации и навигации.</p>
                </div>
                
                <div>
                    <h2 className="font-bold text-3xl sm:text-xl
                                    xl:pb-6
                                    lg:pb-6  
                                    md:pb-4 
                                    sm:pb-2">Модульность</h2>
                <p>Вы можете собирать любые варианты полетного контроллера, обеспечивать многократную отказоустойчивость, расширять функционал, или конструировать свои дополнительные модули, на основе боковых разьемов и функционала в них заложенного</p>
                </div>
                
        </section>
        </>
    )
}
export default ImplementFeatures;